/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostReleasePolicyPathParams = NonNullable<operations['PostReleasePolicy']['parameters']['path']>;

export type PostReleasePolicyRequestBody = OperationRequestBodyContent<operations['PostReleasePolicy']>;

export interface Input extends PostReleasePolicyPathParams {
  apiVersion?: string;
  body: PostReleasePolicyRequestBody;
  header: NonNullable<operations['PostReleasePolicy']['parameters']['header']>;
}

export async function PostReleasePolicy(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/release-policies', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
